var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5436 13.3644C14.187 13.792 13.7928 14.187 13.3653 14.5436L18.5779 19.7562C18.9029 20.0813 19.4312 20.0813 19.7562 19.7562C20.0812 19.4312 20.0812 18.9029 19.7562 18.5779L14.5436 13.3644ZM7.50016 0C11.6394 0 15.0003 3.3609 15.0003 7.50016C15.0003 11.6394 11.6394 15.0003 7.50016 15.0003C3.3609 15.0003 0 11.6394 0 7.50016C0 3.3609 3.3609 0 7.50016 0Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/Explore.90bff617.svg";
export { ForwardRef as ReactComponent };